import React from 'react'

import AppQuickAdd from "../../quick-add"
import AddLocalSettings from "../../local-settings"
import NewProject_SelectTemplate from "./select-template/select-template"
import NewProject_AddFromTemplate from "./add-from-template/add-from-template"
import NewProject_AddFromSharedTemplate from "./add-from-template/add-from-shared-template"
import NewProject_SelectTemplateFromLibrary from "./select-template/select-template-from-library"

type Props = {
    app         : AppQuickAdd
    initParams  : any
}

export enum NewProject_SelectedType {
    TEMPLATE                        = 'template',
    SHARED                          = 'shared',
    SHARED_REDIRECTED               = 'shared-redirected',
    SELECT_TEMPLATE                 = 'select-template',
    SELECT_TEMPLATE_FROM_LIBRARY    = 'select-template-from-library',
}

// const debug = "NewPageMain"
const debug = false

export default class NewProjectMain extends React.Component<Props, any> {

    public localSettings: AddLocalSettings

    constructor(props: Props) {
        super(props)

        const { initParams } = props

        const state = {
            initParams      : initParams,
            selectedType    : initParams.templateId ? NewProject_SelectedType.TEMPLATE : initParams.projectType ? initParams.projectType : null,
            templateId      : initParams.templateId ? initParams.templateId : null,
            organizationId  : gd.companyId,
        }

        if (initParams.templatesLibrary) {
            state.selectedType = NewProject_SelectedType.SELECT_TEMPLATE_FROM_LIBRARY
        }

        this.state = state

        this.localSettings = props.app.localSettings
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const { initParams } = nextProps

        if (this.state.selectedType !== initParams.projectType ||
            !_.isEqual(initParams, this.props.initParams)) {

            this.setState({
                initParams      : nextProps.initParams,
                selectedType    : initParams.projectType,
                templateId      : null
            })
        }
    }

    onSelectType = (type: any, templateId?: ID) => {
        this.setState({
            selectedType    : type,
            templateId      : templateId
        })
    }

    render() {
        switch (this.state.selectedType) {
            case NewProject_SelectedType.TEMPLATE:
                return (
                    <NewProject_AddFromTemplate app                 = {this.props.app}
                                                initParams          = {this.props.initParams}
                                                templateId          = {this.state.templateId}
                                                onSelectType        = {this.onSelectType}/>
                )

            case NewProject_SelectedType.SHARED:
            case NewProject_SelectedType.SHARED_REDIRECTED:
                return (
                    <NewProject_AddFromSharedTemplate app               = {this.props.app}
                                                      initParams        = {this.props.initParams}
                                                      templateId        = {this.state.templateId}
                                                      redirected        = {this.state.selectedType === NewProject_SelectedType.SHARED_REDIRECTED}
                                                      onSelectType      = {this.onSelectType}/>
                )

            // case 'workfolder':              return this.renderAddFolder();

            case NewProject_SelectedType.SELECT_TEMPLATE_FROM_LIBRARY:
                return  <NewProject_SelectTemplateFromLibrary onSelectType={this.onSelectType}/>

            case NewProject_SelectedType.SELECT_TEMPLATE:
            default:
                return <NewProject_SelectTemplate onSelectType={this.onSelectType}/>
        }
    }
}
